import { IteratorHelper } from 'choerodon-ui/dataset';
const iteratorSome = IteratorHelper.iteratorSome;
const iteratorEvery = IteratorHelper.iteratorEvery;
const iteratorFind = IteratorHelper.iteratorFind;
const iteratorFindIndex = IteratorHelper.iteratorFindIndex;
const iteratorFilterToArray = IteratorHelper.iteratorFilterToArray;
const iteratorReduce = IteratorHelper.iteratorReduce;
const iteratorSliceToArray = IteratorHelper.iteratorSliceToArray;
export { iteratorSome, iteratorEvery, iteratorFind, iteratorFindIndex, iteratorFilterToArray, iteratorReduce, iteratorSliceToArray, };
